import { getFlag } from 'sierra-client/config/global-config'

export function useProgramLearnerEnabled(): boolean {
  const isFlagEnabled = getFlag('program-learner')
  return isFlagEnabled
}
